module.exports = __webpack_public_path__ + "static/media/ios-analytics.4d4bb303.svg";